import { createFileRoute } from "@tanstack/react-router";
import {
    kennelListingsRoute,
    KennelListingsPage,
} from "@/features/provider-home";

export const Route = createFileRoute("/kennel/_dashboard/listings/")({
    validateSearch: kennelListingsRoute.validateSearch,
    ssr: kennelListingsRoute.ssr,
    head: kennelListingsRoute.head,
    component: KennelListingsPage,
});
